import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/FanClub.svg'

export const IconFanClub = IconSVG as IconComponent
